/* eslint dot-notation: 'off' */
import settings from 'settings';
import HttpClient from './http_client';
import SessionsApi from './modules/sessions_api';
import ProfileOptionApi from './modules/profile_option_api';
import UserProfileApi from './modules/user_profile_api';
import UserEnvironmentFeedbackApi from './modules/user_environment_feedback_api';
import UserSearchHistoryApi from './modules/user_search_history_api';
import PlaceApi from './modules/places_api';
import PlaceDestinationApi from './modules/place_destination_api';
import PlaceBuildingApi from './modules/place_building_api';
import FloorSpotsApi from './modules/floor_spots_api';
import SpotsApi from './modules/spots_api';
import FloorThingsApi from './modules/floor_things_api';
import ThingsApi from './modules/things_api';
import TagApi from './modules/tags_api';
import SeasonSettingApi from './modules/season_setting_api';

class ApiClient extends HttpClient {
  constructor() {
    super();

    this.url = `${settings.api.url}`;
    this.version = settings.api.version;
    this.timeout = settings.api.timeout;
    this.storageKey = settings.localStorage.keys.session;
  }

  saveSession(response) {
    if (!Object.keys(response.headers).length) return;
    if (!response.headers['expiry']) return;
    if (!response.headers['client']) return;
    if (!response.headers['access-token']) return;
    if (!response.headers['uid']) return;

    localStorage.setItem(
      this.storageKey,
      JSON.stringify({
        'expiry':       response.headers['expiry'],
        'client':       response.headers['client'],
        'access-token': response.headers['access-token'],
        'uid':          response.headers['uid'],
      }),
    );
  }

  saveSessionForOffice365Auth(authParameter) {
    localStorage.setItem(
      this.storageKey,
      JSON.stringify({
        'expiry': authParameter['expiry'],
        'client': authParameter['client'],
        'access-token': authParameter['access-token'],
        'uid': authParameter['uid'],
      }),
    );
  }

  buildSessionHeaders() {
    const session = this.readSession();
    if (!session) return {};

    const headers = {};
    if (session['client']) headers['client'] = session['client'];
    if (session['access-token']) headers['access-token'] = session['access-token'];
    if (session['uid']) headers['uid'] = session['uid'];

    return headers;
  }

  readSession() {
    return JSON.parse(localStorage.getItem(this.storageKey));
  }

  removeSession() {
    localStorage.removeItem(this.storageKey);
  }

  async isSignedIn() {
    const session = this.readSession();

    if (!session || !session['client'] || !session['access-token'] || !session['uid']) {
      throw new Error();
    }
    await this.validateToken();
  }
}

Object.assign(ApiClient.prototype, SessionsApi);
Object.assign(ApiClient.prototype, ProfileOptionApi);
Object.assign(ApiClient.prototype, UserProfileApi);
Object.assign(ApiClient.prototype, UserEnvironmentFeedbackApi);
Object.assign(ApiClient.prototype, UserSearchHistoryApi);
Object.assign(ApiClient.prototype, PlaceApi);
Object.assign(ApiClient.prototype, PlaceDestinationApi);
Object.assign(ApiClient.prototype, PlaceBuildingApi);
Object.assign(ApiClient.prototype, FloorSpotsApi);
Object.assign(ApiClient.prototype, SpotsApi);
Object.assign(ApiClient.prototype, FloorThingsApi);
Object.assign(ApiClient.prototype, ThingsApi);
Object.assign(ApiClient.prototype, TagApi);
Object.assign(ApiClient.prototype, SeasonSettingApi);

export default new ApiClient();



// WEBPACK FOOTER //
// ./src/libs/api_client/index.js